import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Flex, Space, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs'
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";

const EmployeeSalaryAccumulateTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
  isAmountVisible = true,
  employeeYearAccumulate = []
}) => {
  const { t, i18n } = useTranslation();

  const datamock = [
    {
      accumulateName: "เงินได้คำนวณภาษี",
      accumulateNameEn: "Income tax calculation",
      amount: "126,000.00",
      lastModified: "รสิตา ดารากัย 18/10/2567 10:14 น."
    },
    {
      accumulateName: "ภาษี",
      accumulateNameEn: "Tax",
      amount: "0.00",
      lastModified: "รสิตา ดารากัย 18/10/2567 10:14 น."
    },
    {
      accumulateName: "ประกันสังคม",
      accumulateNameEn: "SocialSecurity",
      amount: "7,500.00",
      lastModified: "รสิตา ดารากัย 18/10/2567 10:14 น."
    }
  ]

  const columns = [
    {
      title: <div className="text-table">{t('accumulate_list')}</div>,
      dataIndex: "code",
      key: "code",
      render: (_, record) => { return <span>{i18n.language === "en" ? record?.nameEn : record?.name}</span> }
    },
    {
      title: <div className="text-table">{t('accumulate.amount')}</div>,
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (text) => (isAmountVisible ? get2DecimalPointsWithCommas(text) : "xxxx.xx"),
    },
    {
      title: <div className="text-table">{t('year_accumulate_list.label.last_modified')}</div>,
      dataIndex: "lastModified",
      key: "lastModified",
      render: (_, record) => {
        let modifiedDate = record?.lastModifiedDate ? dayjs(record?.lastModifiedDate).format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : "DD/MM/BBBB HH:mm") : null
        let unitDate = record?.lastModifiedDate ? (i18n.language === "en" ? "" : " น.") : null

        return (
          <Flex vertical>
            {i18n.language === "en" ?
              <span>
                {(record?.lastModifiedBy?.nameEn || "") + " " + (record?.lastModifiedBy?.surNameEn || "")}
              </span> :
              <span>
                {(record?.lastModifiedBy?.name || "") + " " + (record?.lastModifiedBy?.surName || "")}
              </span>
            }
            <span>{modifiedDate}{unitDate}</span>
          </Flex>
        )
      }
    },
    {
      title: "",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                {
                  key: "2",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={employeeYearAccumulate}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeSalaryAccumulateTable;
